module.exports = __webpack_public_path__ + "static/media/colorbook-details.893dfa29.jpg";